import { styled } from "@mui/material/styles";
import { Box, TableCell, Button } from "@mui/material";
import {
  TABLE_BODY_ROW_HEIGHT,
  TABLE_COMPACT_HEADER_HEIGHT,
  TABLE_COMPACT_HEADER_PADDING,
  TABLE_HEADER_FONT_SIZE,
} from "../Table/constants.js";

const jakartaRootSx = {
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  "& .MuiTypography-root, & .MuiButton-root, & .MuiInputBase-root, & .MuiInputLabel-root, & .MuiMenuItem-root, & .MuiTableCell-root, & .MuiChip-label, & .MuiFormLabel-root, & .MuiSelect-select":
    {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
    },
  "& .MuiTableBody-root .MuiTableRow-root.MuiTableRow-hover:hover": {
    backgroundColor: "#ECF1F7",
  },
};

/* ================= PAGE ================= */


export const PageRoot = styled(Box)(({ theme }) => ({
  ...jakartaRootSx,
  padding: theme.spacing(4),
  height: "100vh",
}));

export const MainCard__body = styled(Box)(({ theme }) => ({
  ...jakartaRootSx,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  height: "auto",
  padding: "20px",
  paddingTop: "30px",
  paddingBottom: "30px",
  borderRadius: "12px",
  justifyContent: "space-around",
  boxShadow: "0px 18px 40px rgba(0,0,0,0.08)",
  
}));

export const TitleWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
}));

/* ================= CARD ================= */

export const Card = styled(Box)(({ theme }) => ({
  ...jakartaRootSx,
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.spacing(3),
  boxShadow: "0px 18px 40px rgba(0,0,0,0.08)",
  overflow: "hidden",
}));

/* ================= TOOLBAR ================= */

export const Toolbar = styled(Box)(({ theme }) => ({
  width: "100%",
  alignSelf: "stretch",
  marginTop: "-10px",
  padding: theme.spacing(0, 0, 3, 0),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  flexWrap: "wrap",
}));

export const SearchBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
  minWidth: 340,
}));

export const FiltersWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
}));

export const FiltersButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  textTransform: "none",
  fontWeight: 700,
  paddingInline: theme.spacing(2.5),
}));

/* ================= TABLE ================= */
export const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  fontSize: TABLE_HEADER_FONT_SIZE,
  fontWeight: 700,
  color: "rgba(0,0,0,0.70)",
  backgroundColor: "#F9F9F9",
  borderBottom: 0,
  height: TABLE_COMPACT_HEADER_HEIGHT,
  padding: TABLE_COMPACT_HEADER_PADDING,
  lineHeight: "0px",
  whiteSpace: "nowrap",
}));

export const BodyCell = styled(TableCell)(({ theme }) => ({
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  fontSize: 14,
  color: theme.palette.text.primary,
  height: TABLE_BODY_ROW_HEIGHT,
  padding: "0 0 0 16px",
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

/* ================= FOOTER ================= */

export const Footer = styled(Box)(({ theme }) => ({
  width: "100%",
  alignSelf: "stretch",
  padding: theme.spacing(2.5, 0),
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const TotalText = styled(Box)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.text.secondary,
}));

export const typographyClass = {
  fontFamily: "Plus Jakarta Sans",
  fontSize: "26px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "140%",
};
